export type AREngine = 'xr8' | 'mindar';

const MOBILE_UA = /Android|iPhone|iPad|iPod/i;

export const isMobileDevice = (): boolean => {
    if (typeof navigator === 'undefined') return false;
    return MOBILE_UA.test(navigator.userAgent);
};

/** Derive MindAR `.mind` path from an 8th Wall target JSON URL in the same folder. */
export const getMindTargetUrl = (targetJsonUrl: string): string =>
    targetJsonUrl.replace(/[^/]+\.json$/, 'target.mind');

/**
 * Pick AR engine: 8th Wall on mobile, MindAR on desktop/laptop.
 * Override with REACT_APP_AR_ENGINE=xr8|mindar|auto
 */
export const getPreferredAREngine = (): AREngine => {
    const override = process.env.REACT_APP_AR_ENGINE;
    if (override === 'xr8' || override === 'mindar') {
        return override;
    }
    return isMobileDevice() ? 'xr8' : 'mindar';
};
